export const iconColors = Object.freeze({
  WHITE: 'icon-white',
  GREY: 'icon-grey',
  LIGHT_GREY: 'icon-light-grey',
  BLACK: 'icon-black',
  ORANGE: 'icon-orange',
  LIGHT_ORANGE: 'icon-light-orange',
  BLUE: 'icon-blue',
  LINK_BLUE: 'icon-link-blue',
  RED: 'icon-red',
  BRIGHT_RED: 'icon-bright-red',
  GREEN: 'icon-green',
  LIGHT_GREEN: 'icon-light-green'
});

export const iconSizes = Object.freeze({
  XS: '14px',
  SMALL: '18px',
  DEFAULT: '20px',
  LARGE: '26px',
  HUGE: '30px'
});
